<template>
   
    <div class="duplicate">
        <div class="row">
            <div class="lhs">
                <div class="data">
                    <div class="label">{{brandedPublicId}}</div>
                    <div class="value">{{forename}} {{surname}}</div>
                </div>
            </div>
            <div class="rhs">
                <div class="data">
                    <div class="label">{{country}}</div>
                    <div class="value">{{city}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="lhs">
                <div class="data-small"><strong>Status:</strong> {{status}}</div>
                <div class="data-small" v-if="lastContactDate != '' && lastContactDate != null"><strong>Last Contacted:</strong> {{lastContactDate | formatDate}}</div>
                <div class="data-small" v-else>Not Yet Contacted</div>
            </div>
            <div class="rhs">
                <div class="buttons">
                    <a :href="sfLink" target="_blank" class="button hollow" :class="{disabled:disabled}">View</a>
                    <a href="" class="button" @click.prevent="$emit('select-id', id)" :class="{disabled:disabled}">Update</a>
                </div>
            </div>
        </div>
    </div>    
                
</template>

<script>
    export default {
        name: 'DuplicateCandidate',
        components: {},
        props: [
            'disabled',
            'id',
            'brandedPublicId',
            'forename',
            'surname',
            'email',
            'city',
            'country',
            'lastContactDate',
            'status'
        ],
        computed: {
            environment() {
                return this.$store.state.app.environment || '';
            },
            theme() {
                return this.$store.state.user.theme || '';
            },
            sfLink() {
                let url = this.environment;
                if (this.theme === 'lightning') {
                   url += '/lightning/r/Contact/' + this.id + '/view?0.source=alohaHeader';
                }  else {
                   url += '/apex/ContactView?id=' + this.id;
                }
                return url;
            }
        }
    }
</script>

<style scoped>
    
     .duplicate { background-color: #fff; }
        .duplicate .row {padding: 1rem; transition: .25s; display: flex; flex-wrap: wrap;}
        .duplicate .row + .row {padding-top: 0rem;}
            .duplicate > .row .lhs {flex-grow: 1; margin-top: auto;}
            .duplicate > .row .rhs {text-align: right; margin-top: auto;}
        .duplicate .data-small {font-size: .8rem;}
        .duplicate .data-small + .data-small {margin-top: .25rem;}
    
        .duplicate .data + .data {margin-top: 1rem;}
            .duplicate .data .label {font-size: .7rem; font-weight: bold; text-transform: uppercase;}
            .duplicate .data .value {font-family: 'Roboto Condensed', sans-serif; font-size: 1.25rem; font-weight: bold;}
    
        .duplicate .buttons {margin: 0 -.25rem;}
            .duplicate .buttons .button {margin: 0 .25rem;}
    
        @media screen and (max-width: 550px) {
            .duplicate > .row .lhs, .duplicate > .row .rhs {width: 100%; text-align: left;}
            .duplicate > .row .lhs {padding-bottom: 1rem;}
            .duplicate .buttons {text-align: right;}
        }

    
</style>